// in src/comments/ApproveButton.js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { UPDATE, useNotify, useRecordContext } from 'react-admin';
import FlatButton from '@mui/material/Button';
import CheckIcon from '@mui/icons-material/Check';
import superDataProvider from '../../../dataprovider';

const FinishActivityButton = () => {
  // constructor() {
  //   super();
  //   this.handleClick = this.handleClick.bind(this);
  // }
  const record = useRecordContext();
  const handleClick = () => {
    // const { record } = this.props;
    // const { type } = record;
    const data = {
      fini: true,
      id: record.id_original,
      row_updated: new Date().toISOString(),
    };

    superDataProvider(UPDATE, type, { data }).then(() => {
      useNotify('Activité finie');
      document.querySelector('[title="Refresh"]').click();
    }).catch(() => {
      useNotify('Error: comment not approved', 'warning');
    });
  }


  // const { props } = this;
  // const { record } = props;

  if (!record.fini) {
    return (
      <FlatButton color="secondary" onClick={() => handleClick()}>
        <CheckIcon />
        Finir
      </FlatButton>
    );
  } else {
    return (
      <FlatButton color="secondary" onClick={() => handleClick()} disabled>
        <CheckIcon />
        Finir
      </FlatButton>
    );
  }
}

FinishActivityButton.propTypes = {
  record: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
  ]),
};

FinishActivityButton.defaultProps = {
  record: {},
};

export default FinishActivityButton;
